import { GridHeader } from './REPORT_CONFIG';

export const CTV_BRANDSAFETY_TEMPLATE =
  '<span class="rating-${brandSafetyRisk}">' +
  '<span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Low"/>low</span>' +
  '<span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Medium"/>medium</span>' +
  '<span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Icon Meter High"/>high</span></span>';

export const CTV_APPAGERISK_TEMPLATE =
  '<span class="rating-${appAgeRisk}">' +
  '<span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Low"/>low</span>' +
  '<span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Medium"/>medium</span>' +
  '<span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Icon Meter High"/>high</span></span>';

export const CTV_BOOLEAN_TEMPLATE =
  '<img class="icon-yes mr-1" src="/assets/images/icon-indicator-yes.svg" alt="Icon Yes"/>' +
  '<img class="icon-no mr-1" src="/assets/images/icon-indicator-no.svg" alt="Icon No"/>';

export const CTV_INFO_TEMPLATE =
  ' <div class="appTitle pl-md-4">' +
  '  <div class="aptitleCont">' +
  '    <a class="ctv-link id-${indexId} appid-${appId} device-${device} region-${region} section-app-overview">' +
  '     <img class="appIcon id-${indexId}" ' +
  '             src="${appIcon}" alt="App Icon"/>' +
  '    </a>' +
  '    <div class="titleCont">' +
  '      <div class="title">' +
  '        <a class="btn btn-link p-0 ctv-link id-${indexId} appid-${appId} device-${device} region-${region} section-app-overview" ' +
  '           href="${ctvInsightsLink}"' +
  '           data-html="true" data-toggle="tooltip" entooltip="" data-animation="false" title="${appTitle}" style="cursor: pointer;">${appTitle}</a>\n' +
  '      </div>\n' +
  '      <div class="title-cont-inner align-items-center rating-${pixalateRisk} device-${device} freemium-${isFreemium}">' +
  '       <img class="device roku mr-1" src="/assets/images/roku.jpg" width="16" class="mr-1" alt="Roku Icon"/>' +
  '       <img class="device firetv mr-1" src="/assets/images/firetv.jpg" width="16" class="mr-1" alt="Fire TV Icon"/>' +
  '       <img class="device samsung mr-1" src="/assets/images/samsung.jpg" width="16" class="mr-1" alt="Samsung Icon"/>' +
  '       <img class="device tvos mr-1" src="/assets/images/tvos.jpg" width="16" class="mr-1" alt="tvOS Icon"/>' +
  '       <span class="risk-label">Risk: </span>' +
  '       <span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Low"/>low</span>' +
  '       <span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Medium"/>medium</span>' +
  '       <span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Icon Meter High"/>high</span>' +
  '       <span class="risk-value freemium-lock"><i class="fa fa-lock"></i></span>' +
  '      </div>' +
  '    </div>' +
  '  </div>' +
  '  <ul class="list-unstyled" style="left: 99px; top: 351px;">' +
  '     <li class="ctv-details-category">' +
  '       <div>Category:</div>' +
  '       <div class="white-space-nowrap"> ${category} </div>' +
  '     </li>' +
  '     <li>' +
  '       <div>App ID:</div>' +
  '       <div> ${appId} </div>' +
  '     </li>' +
  '     <li class="bundleId-cont bundleId-length-${bundleIdLength} pix-popover">' +
  '       <div>Matched Bundle ID(s):</div>' +
  '       <div class="bundleId"> ' +
  '         ${bundleId} ' +
  '         <div class="pix-popover-content">' +
  '             ${bundleIdList}' +
  '         </div>' +
  '       </div>' +
  '     </li>' +
  '     <li>' +
  '       <div>Developer Name:</div>' +
  '       <div class="white-space-nowrap"> ${developerName} </div>' +
  '     </li>' +
  '     <li class="developer-website">' +
  '       <div>Developer Website:</div>' +
  '       <div> <a href="${developerWebsite}" target="_blank"><i class="fa fa-external-link"></i> Go to Website</a> ' +
  '           <span class="not-available">N/A</span>' +
  '       </div>' +
  '     </li>' +
  '     <li>' +
  '       <div>Total Apps:</div>' +
  '       <div> ${developerTotalApps} </div>' +
  '     </li>' +
  '     <li class="trusted-seller">' +
  '       <div>Trusted Seller:</div>' +
  '       <div> ' +
  '           <img src="https://cdn.pixalate.com/sellers/icons/apn/16x16/${trustedSellerId}.jpg?cb=' +
  Math.random() +
  '" onerror="this.style.opacity = 0" width="16" height="16" alt="Logo"/>&nbsp;' +
  '           ${trustedSellerName} ' +
  '       </div>' +
  '     </li>' +
  '  </ul> ' +
  '  </div>';

export const APP_MFA_TEMPLATE =
  '<span class="rating-${mfaRating}">' +
  ' <span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Risk Low"/>low</span>' +
  ' <span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Risk Medium"/>medium</span>' +
  ' <span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Risk High"/>high</span>' +
  '</span>';

export const CTV_GRID_HEADERS: Array<GridHeader> = [
  {
    label: 'Title',
    key: 'appTitle',
    sort: '',
    sortColumnKey: 'appTitle',
    hoverKey: '',
    template: CTV_INFO_TEMPLATE,
    hidden: false,
    format: null
  },
  {
    label: 'App Icon',
    key: 'appIcon',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'App ID',
    key: 'appId',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Device',
    key: 'device',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Region',
    key: 'region',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Risk',
    key: 'pixalateRisk',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Category',
    key: 'category',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'App ID',
    key: 'appId',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Matched Bundle ID(s)',
    key: 'bundleId',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'array'
  },
  {
    label: 'Bundle ID Length',
    key: 'bundleIdLength',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Bundle ID List',
    key: 'bundleIdList',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Developer Name',
    key: 'developerName',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Trusted Seller Id',
    key: 'trustedSellerId',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Trusted Seller Name',
    key: 'trustedSellerName',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Developer Website',
    key: 'developerWebsite',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'urlfix'
  },
  {
    label: 'Total Apps',
    key: 'developerTotalApps',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Est. IVT',
    key: 'ivtRate',
    sort: '',
    sortColumnKey: 'ivtRate',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase">' +
      '<a class="ctv-link id-${indexId} appid-${appId} device-${device} region-${region} section-app-invalid-traffic">${ivtRate}</a>' +
      '</div>' +
      '<div class="change-number">${ivtRateChange}</div>',
    hidden: false,
    format: 'percent'
  },
  {
    label: 'IVT Rate Change',
    key: 'ivtRateChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'percent'
  },
  {
    label: 'Est. SSAI',
    key: 'ssaiRate',
    sort: '',
    sortColumnKey: 'ssaiRate',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase">' +
      '<a class="ctv-link id-${indexId} appid-${appId} device-${device} region-${region} section-app-overview">${ssaiRate}</a>' +
      '</div>' +
      '<div class="change-number">${ssaiRateChange}</div>',
    hidden: false,
    format: 'percent'
  },
  {
    label: 'SSAI Rate Change',
    key: 'ssaiRateChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'percent'
  },
  {
    label: 'Est. Transparent SSAI',
    key: 'transparentSsaiRate',
    sort: '',
    sortColumnKey: 'transparentSsaiRate',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase">' +
      '<a class="ctv-link id-${indexId} appid-${appId} device-${device} region-${region} section-app-risk-overview">${transparentSsaiRate}</a>' +
      '</div>' +
      '<div class="change-number">${transparentSsaiRateChange}</div>',
    hidden: false,
    format: 'percent'
  },
  {
    label: 'Transparent SSAI Rate Change',
    key: 'transparentSsaiRateChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'percent'
  },
  {
    label: 'Brand Safety Risk',
    key: 'brandSafetyRisk',
    sort: '',
    sortColumnKey: 'brandSafetyRisk',
    hoverKey: '',
    template: CTV_BRANDSAFETY_TEMPLATE,
    hidden: false,
    format: null
  },
  {
    label: 'App Age Risk',
    key: 'appAgeRisk',
    sort: '',
    sortColumnKey: 'appAgeRisk',
    hoverKey: '',
    template: CTV_APPAGERISK_TEMPLATE,
    hidden: false,
    format: null
  },
  {
    label: 'MFA Risk',
    key: 'mfaRating',
    sort: '',
    hoverKey: '',
    sortColumnKey: 'mfaRating',
    template: APP_MFA_TEMPLATE,
    hidden: false,
    format: null,
    tooltip: `Pixalate's assessment of the risk of the app being deemed MFA, based on Pixalate's MFA detection methodology`
  },
  {
    label: 'CVAA Compliant',
    key: 'isCvaaCompliant',
    sort: '',
    sortColumnKey: 'isCvaaCompliant',
    hoverKey: '',
    template:
      '<div class="text-capitalize boolean-${isCvaaCompliant}">' +
      CTV_BOOLEAN_TEMPLATE +
      '${isCvaaCompliant}</div>',
    hidden: false,
    format: 'boolean'
  },
  {
    label: 'App-ads.txt Detected',
    key: 'isAdsTxtEnabled',
    sort: '',
    sortColumnKey: 'isAdsTxtEnabled',
    hoverKey: '',
    template:
      '<div class="text-capitalize boolean-${isAdsTxtEnabled}">' +
      CTV_BOOLEAN_TEMPLATE +
      '${isAdsTxtEnabled}</div>',
    hidden: false,
    format: 'boolean'
  }
];
